document.addEventListener('DOMContentLoaded', function () {
  const accountIcons = document.querySelectorAll('.header__icon--account');
  const modal = document.getElementById('login-popup');

  accountIcons.forEach(icon => {
    icon.addEventListener('click', function (e) {
      e.stopPropagation(); // Prevents the document click listener from firing
      const dataId = this.dataset.id;

      document.querySelector('.verifyotp-button').setAttribute("data-id", dataId);
      modal.classList.toggle("open");
      document.body.classList.toggle("login_open");

      const phoneInput = document.getElementById('phone_number');
      const phoneNumber = phoneInput.value.trim();

      if (phoneNumber) {
        // Call your OTP function
        sendOTP(phoneNumber);
      }
    });
  });

  // Close modal when clicking outside of it
  document.addEventListener('click', function (e) {
    const isClickInside = modal.contains(e.target);
    const isAccountIcon = [...accountIcons].some(icon => icon.contains(e.target));

    if (
      document.body.classList.contains('login_open') &&
      !isClickInside &&
      !isAccountIcon
    ) {
      modal.classList.remove("open");
      document.body.classList.remove("login_open");
    }
  });
});

function sendOTP() {
  const phone = document.getElementById("phone_number").value.trim();
  const otpMessage = document.getElementById("otp-message");

  if (!phone || phone.length < 10) {
    otpMessage.innerText = "Please enter a valid mobile number.";
    otpMessage.style.color = "red";
    return;
  }

  const pathSegments = window.location.pathname.split('/');
  const stickysessionId = pathSegments[pathSegments.length - 1];

  fetch(`https://api.analysis.drskin.ai/server/api/auth/otp/request`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Cookie': `JSESSIONID=${stickysessionId}`
    },
    body: JSON.stringify({ 
      phone_number: `+91${phone}`, 
      country_code: "+91" 
    })
  })
  .then(response => {
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return response.json();
  })
  .then(data => {
    otpMessage.innerText = "OTP sent successfully.";
    otpMessage.style.color = "green";
    
    document.getElementById("step1").style.display = "none";
    document.getElementById("step2").style.display = "block";

    // Mask phone number: XXXXXX1234
    const maskedPhone = phone.replace(/^(\d{6})(\d{4})$/, 'XXXXXX$2');
    document.querySelector(".phone-number").innerText = maskedPhone;

    // Handle resend button timer
    const btn = document.querySelector(".resendotp");
    startResendTimer(btn);

    // console.log("OTP sent successfully", data);
  })
  .catch(error => {
    otpMessage.innerText = "Failed to send OTP.";
    otpMessage.style.color = "red";
    // console.error('OTP Send Error:', error);
  });
}

// Separate timer logic (cleaner)
function startResendTimer(btn) {
  let timer = 30;
  btn.style.pointerEvents = "none";
  btn.style.opacity = "0.6";
  btn.textContent = `Resend OTP in ${timer}s`;

  const countdown = setInterval(() => {
    timer--;
    btn.textContent = `Resend OTP in ${timer}s`;

    if (timer <= 0) {
      clearInterval(countdown);
      btn.style.pointerEvents = "auto";
      btn.style.opacity = "1";
      btn.textContent = "Resend OTP";
    }
  }, 1000);
}


function verifyOTP() {
  const phone = document.getElementById("phone_number").value.trim();
  const otpInputs = document.querySelectorAll(".otp-box");
  const otp = Array.from(otpInputs).map(input => input.value.trim()).join("");
  const messageDiv = document.getElementById("otp-message");

  // Remove previous error class
  otpInputs.forEach(input => input.classList.remove("error"));

  if (otp.length !== 4) {
    messageDiv.innerText = "Please enter the 4-digit OTP.";
    document.getElementById("otp-message").style.color = "red";
    otpInputs.forEach(input => input.classList.add("error"));
    return;
  }

  fetch(`https://api.analysis.drskin.ai/server/api/auth/otp/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ phone_number: `+91${phone}`, code: otp })
  })
  .then(response => {
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  })
  .then(data => {
    // console.log(data, 'data');
    // console.log(decryptForShopify(data.data.shopifyKey, data.data.token), 'Token');
    
    messageDiv.innerText = "OTP verified successfully.";
    otpInputs.forEach(input => messageDiv.classList.add("success"));
    localStorage.setItem('Login Id', JSON.stringify(data.data));
    localStorage.setItem('Phone number', `${phone}`);

    const vdataId = document.querySelector('.verifyotp-button').getAttribute('data-id');
    window.location.reload();
    document.getElementById('login-popup').classList.remove("open");
    document.body.classList.remove("login_open");
  })
  .catch(error => {
    messageDiv.innerText = "You’ve entered wrong OTP, Please check!";
    document.getElementById("otp-message").style.color = "red";
    otpInputs.forEach(input => input.classList.add("error")); // Highlight boxes red
    // console.error("Verify OTP Error:", error);
  });
}

function moveToNext(currentInput, index) {
  const nextInput = currentInput.nextElementSibling;
  if (nextInput && nextInput.classList.contains('otp-box') && currentInput.value.length === 1) {
    nextInput.focus();
  }
}

function editPhoneNumber() {
  document.getElementById("step2").style.display = "none";
  document.getElementById("step1").style.display = "block";
  otpInputs.forEach(input => input.classList.remove("error")); // Highlight boxes red
}

async function decryptForShopify(base64) {
  // Decode the base64 string into bytes
  const combined = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
  // Extract IV (first 16 bytes) and the encrypted data
  const iv = combined.slice(0, 16);
  const encrypted = combined.slice(16);
  // Define the 16-byte AES key as in your Java code
  const secretKeyString = "IFMedTechUUIDdev"; // must match SECRET_KEY_BYTES in Java
  const keyBytes = new TextEncoder().encode(secretKeyString);
  if (keyBytes.length !== 16) {
    throw new Error("Key must be 16 bytes for AES-128.");
  }
  // Import the raw key into the Web Crypto API
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC" },
    false,
    ["decrypt"]
  );
  // Perform the decryption
  const decryptedBuffer = await crypto.subtle.decrypt(
    {
      name: "AES-CBC",
      iv: iv
    },
    cryptoKey,
    encrypted
  );
  // Convert decrypted bytes to UTF-8 string
  return new TextDecoder().decode(decryptedBuffer);
}

const inputs = document.querySelectorAll(".otp-box");

inputs.forEach((input, index) => {
  input.addEventListener("input", () => {
    if (input.value && index < inputs.length - 1) {
      inputs[index + 1].focus(); // move to next
    }
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Backspace" && !input.value && index > 0) {
      inputs[index - 1].focus(); // move back if empty
    }
  });
});
